/**
 * Legacy RefundsApiService module — preserved as an empty AngularJS module
 * so existing dependencies (`acme.common.service.refundsApi`) keep resolving.
 *
 * The actual RefundsApiService is now exposed through the Angular 18
 * ApiService facade. Implementation:
 *   apps/b2b-frontend/app/core/api/refunds/refunds-api.service.ts
 */
angular.module("acme.common.service.refundsApi", []);
